export function generateFilename({
  rowid = 0,
  filename = null,
  category = null,
  fileExtension,
  practiceid,
  departmentid,
  patientid,
  appointmentid = null,
  currentUser,
}) {

  console.log(practiceid,departmentid,patientid,currentUser)
  if (!fileExtension || !practiceid || !departmentid || !patientid || !currentUser) {
    throw new Error("Missing required parameters. You had one job.");
  }


  const basicUser = currentUser !== "PRO";

  let isEdit = false;
  let submittedFileName = "";
  let sourceFileName = "";

  if (rowid > 0) {
    isEdit = true;
    if (filename) {
      const parts = filename.split(".");
      if (parts.length > 1) {
        sourceFileName = `${parts[0]}_${category}_edit.${parts[parts.length - 1]}`;
      } else {
        sourceFileName = `${filename}_${category}_edit`;
      }
    }
  }

  const now = new Date();
  const uniqueTimestamp = now
    .toISOString()
    .replace(/[-:.TZ]/g, "")
    .slice(0, 14); // YYYYMMDDHHMMSS, because chaos loves formatting

  if (basicUser) {
    submittedFileName = `${practiceid}_${departmentid}_${patientid}_${uniqueTimestamp}.${fileExtension}`;
  } else {
    submittedFileName = `${practiceid}_${departmentid}_${patientid}_${appointmentid}_${uniqueTimestamp}.${fileExtension}`;
  }

  if (isEdit) {
    submittedFileName = sourceFileName;
  }

  return  submittedFileName

}
 export const getInitials = (firstName, lastName) => {
  const f = typeof firstName === "string" ? firstName.trim() : "";
  const l = typeof lastName === "string" ? lastName.trim() : "";

  if (!f && !l) return "?";

  return `${f.charAt(0)}${l.charAt(0)}`.toUpperCase();
};